<template>
   <div>
       <router-link :to="{ name: 'asset_groups', query: { id: data.id, name: data.name,  companyId: $route.query.companyId }}" class=" mr-2">
            <button type="button" class="asset-buttton primary">
                {{$t('text.clickButtons.viewGroup')}}
            </button>
       </router-link>
        <button type="button" class="asset-buttton info mr-2" v-on:click="editGroup" >
            {{$t('text.actionButtons.edit')}}
        </button>
       <button type="button"  class="asset-buttton danger" v-on:click="deleteGroup" >
            {{$t('text.actionButtons.delete')}}
        </button>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
    data() {
        return {
            data: {},
        };
    },
    methods: {
        editGroup() {
            this.$eventHub.$emit("setEditModalValues", this.data)
        },
        deleteGroup() {
            let dialog = confirm("Are you sure you want to delete this asset group")
            if(!dialog) {
                return;
            }
            this.axios
                .delete(
                `${configObject.apiBaseUrl}/Assets/asset-groups/${this.data.id}`,
                configObject.authConfig()
                )
                .then(() => {
                    this.$eventHub.$emit("refreshAssetsGroup");
                    this.$toast.open({
                        message: "Successfully deleted asset group",
                        type: "success",
                        duration: 3000
                    });
                })
                .catch(error => {
                    this.$toast.open({
                        message: error.response.data.message,
                        type: "error",
                        duration: 10000
                    });
                });
        }
    }
};
</script>